<form [formGroup]="form" (ngSubmit)="login(email.value, password.value)">
	<div>
		<text-input
			#email
			type="text"
			name="email"
			placeHolder="Email"
			formControlName="email"
			[error]="formErrors.email"
			[form]="form"
			[styles]="{ width: '100%' }"
		></text-input>
	</div>
	<div>
		<text-input
			#password
			placeHolder="Password"
			formControlName="password"
			type="password"
			[error]="formErrors.password"
			[form]="form"
			[styles]="{ width: '100%' }"
		></text-input>
	</div>
	<div>
		<flat-button [styles]="{ width: '100%' }" color="primary">Login</flat-button>
	</div>
</form>
